/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Row,
  Spin,
} from 'antd';
import Table from 'components/Table';
import currencyFormatter from 'utils/currencyFormatter';
import { getPercepciones } from 'api/nominas/percepciones/percepciones';
import { checkToken } from 'api/utils';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

const NominasPercepciones = ({ data }) => {
  const [loading, setLoading] = useState(false);
  const [percepciones, setPercepciones] = useState([]);

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _percepciones,
      ] = await Promise.all([
        getPercepciones(),
      ]);
      if (mounted) {
        setPercepciones(_percepciones);
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const totalPercepciones = data.reduce((suma, actual) => suma + (actual.importe || 0), 0);

  const columns = [
    {
      titleText: 'Percepciones',
      dataIndex: 'percepcion',
      key: 'percepcion',
      width: 250,
      render: (val) => {
        const _percepcion = percepciones.find((e) => e.id === val);
        return `${_percepcion?.clave} - ${_percepcion?.descripcion}`;
      },
    },
    {
      titleText: 'Importe',
      dataIndex: 'importe',
      key: 'importe',
      width: 150,
      align: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
  ];

  const summaryCells = [
    {
      label: 'Total',
      value: totalPercepciones,
      valueAlign: 'right',
      render: (val) => currencyFormatter(val || 0),
    },
  ];

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={data}
          summaryCells={summaryCells}
          allowExportPDF={false}
        />
      </Spin>
    </Row>
  );
};

export default NominasPercepciones;
